import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const UploadLink = styled(Link)`
  text-decoration: none;
`;
